import type { RiskLevel } from '../types';

export function deriveRiskLevel(effectiveDebits: number, requiresReferral: boolean): RiskLevel {
  if (requiresReferral) {
    return 'Highest Risk';
  }

  if (effectiveDebits >= 301) {
    return 'Higher Risk';
  }

  if (effectiveDebits >= 151) {
    return 'Moderate Risk';
  }

  if (effectiveDebits >= 100) {
    return 'Lower Risk';
  }

  return null;
}

export function referralDisclaimer(requiresReferral: boolean): string | null {
  return requiresReferral ? 'Referral required: at least one selection prevents automated scoring.' : null;
}
